import { BOOKINGHTTP, HTTP, HTTP_CONFIG } from '../../common/http';

import {
  CLEAR_QUOTE,
  CLEAR_VEHICLES,
  CREATE_QUOTE,
  DELETE_VEHICLE,
  FETCH_BOOKING,
  FETCH_CURRENCIES,
  FETCH_DONATIONS,
  FETCH_EXTRAS,
  FETCH_LOCATIONS,
  FETCH_MODIFICATION,
  FETCH_RENTAL_CODE,
  FETCH_MODIFICATION_EXTRAS,
  FETCH_GUEST_BOOKING,
  FETCH_SELECTED_EXTRAS,
  FETCH_TOTALS,
  FETCH_VEHICLE_INSURANCE_OPTIONS,
  FETCH_VEHICLES,
  SET_CURRENCY,
  SET_CUSTOMER,
  SET_CUSTOMER_STATE,
  SET_DROPOFF_DATE,
  SET_DROPOFF_LOCATION,
  SET_DROPOFF_TIME,
  SET_GRAND_TOTAL,
  SET_LOADING,
  SET_PICKUP_DATE,
  SET_PICKUP_LOCATION,
  SET_PICKUP_TIME,
  SET_SELECTED_VEHICLE_TYPE,
  TOGGLE_PREMIUM_VEHICLE_UPGRADE,
  UPDATED_BOOKING,
  UPDATE_PAYMENT_TYPE,
  UPDATE_DONATION,
  SET_TAB
} from './mutation-types';
import {SET_ORIGINAL_QUOTE, SET_ORIGINAL_DONATION} from "../edit-booking/mutation-types";

const localDomain = window.greenmotion ? (window.greenmotion.portalEndpoint || '') : '';

export function setLoading({ commit }, loading) {
  commit(SET_LOADING, loading);
};

export function fetchLocations({ commit }) {
  return HTTP.get(`locations?include=country`)
    .then((response) => commit(FETCH_LOCATIONS, response.data.data));
};

export function fetchCurrencies({ commit, state }) {
  return HTTP.get(`currencies`)
    .then(response => commit(FETCH_CURRENCIES, response.data.data));
};

export function fetchQuote({ commit, state }, quoteId) {
  return HTTP.get(`quotes/${quoteId}`, {
    params: {
      include: 'selected_vehicle.vehicle,selected_vehicle.product,selected_vehicle.vehicle.product,selected_vehicle.vehicle.products,selected_vehicle.selected_insurance_options.insurance_option,selected_extras.extra,totals,user.loyalty_level,user.cards,customer,signed_routes'
    }
  }).then((response) => {
    commit(CREATE_QUOTE, response.data.data);
    return response;
  });
};

export function fetchOriginalQuote({ commit, state }, { bookingReference, quoteId }) {
  return new Promise((resolve, reject) => {
    return HTTP.get(`bookings/${bookingReference}/quote/${quoteId}`, {
      params: {
        include: 'pickup_location,dropoff_location,selected_vehicle.vehicle,selected_vehicle.product,selected_vehicle.vehicle.product,selected_vehicle.vehicle.products,selected_vehicle.selected_insurance_options.insurance_option,selected_extras.extra,totals,user.loyalty_level,user.cards,customer,signed_routes'
      }
    }).then((response) => {
      commit(SET_ORIGINAL_QUOTE, response.data.data);
      resolve(response);
    });
  });
};

export function fetchBookingQuote({ commit, state }, { bookingReference, quoteId }) {
  return new Promise((resolve, reject) => {
    return HTTP.get(`bookings/${bookingReference}/quote/${quoteId}`, {
      params: {
        include: 'pickup_location,dropoff_location,selected_vehicle.vehicle,selected_vehicle.product,selected_vehicle.vehicle.product,selected_vehicle.vehicle.products,selected_vehicle.selected_insurance_options.insurance_option,selected_extras.extra,totals,user.loyalty_level,user.cards,customer,signed_routes'
      }
    }).then((response) => {
      commit(CREATE_QUOTE, response.data.data);
      resolve(response);
    });
  });
};

export function setQuote({ commit, state }, quote) {
  commit(CREATE_QUOTE, quote);
};

export function fetchBooking({ commit, state }, bookingId) {
  return new Promise((resolve, reject) => {
      HTTP.get(`bookings/${bookingId}/json`)
      .then((response) => {
        const booking = response?.data?.data;

        commit(FETCH_BOOKING, response?.data?.data);
        localStorage.setItem(
          'booking',
          JSON.stringify({ bookingReference: response?.data?.data?.reference, complete: true })
        );

        resolve(response);
      })
      .catch(error => console.log(error));
  });
};

export function fetchBookingNoCommit({ commit, state }, bookingId) {
  return new Promise((resolve, reject) => {
    HTTP.get(`bookings/${bookingId}/json`)
      .then((response) => {
        resolve(response);
        return response;
      })
      .catch(error => console.log(error));
  });
};

export function setUpdateBooking({ commit, state }, value) {
  commit(UPDATED_BOOKING, value);
};

export function clearQuote({ commit }) {
  commit(CLEAR_QUOTE);
};

export function fetchQuoteWithAdditionalIncludes({ commit, state }, { quoteId, additionalIncludes }) {
    return HTTP.get(`quotes/${quoteId}`, {
        params: {
            include: `selected_vehicle.vehicle,selected_vehicle,selected_vehicle.vehicle.product,selected_vehicle.product,selected_vehicle.vehicle.products,selected_vehicle.selected_insurance_options.insurance_option,selected_extras.extra,totals,user.loyalty_level,user.cards,customer,${additionalIncludes}`
        }
    }).then((response) => {
        commit(CREATE_QUOTE, response.data.data);

    });
};

export function fetchVehicles({ commit, state }, { quoteId, sortDriveAndGo }) {
  return HTTP.get(`quotes/${quoteId}/vehicles?include=products${sortDriveAndGo}`)
    .then(response => {
      commit(FETCH_VEHICLES, response.data.data);
      return response;
    });
};

export function clearVehicles({ commit }) {
  commit(CLEAR_VEHICLES);
};

export function fetchVehicleInsuranceOptions({ commit, state }, payload) {
  return HTTP.get(`quotes/${payload.quoteId}/vehicles/${payload.vehicleId}/insurance-options`)
    .then(response => commit(FETCH_VEHICLE_INSURANCE_OPTIONS, response.data.data));
};

export function copyExtras({ commit, state }, { quoteId, newQuoteId }) {
  quoteId = quoteId ? quoteId : state.quote.id;
  return HTTP.get(`quotes/${quoteId}/extras?include=profileCountries`)
    .then(response => commit(FETCH_EXTRAS, response.data.data));
}

export function fetchExtras({ commit, state }, quoteId) {
  quoteId = quoteId ? quoteId : state.quote.id;
  return HTTP.get(`quotes/${quoteId}/extras?include=profileCountries`)
    .then(response => {
      commit(FETCH_EXTRAS, response.data.data);
      return response;
    });
};

export function copyUpdateExtras({ commit, state }, { quoteId, originalId }) {
  return HTTP.get(`quotes/${quoteId}/selected-extras/quote/${originalId}/copy`)
    .then(response => {
      commit(FETCH_SELECTED_EXTRAS, response.data.data);
      return response;
    });
};

export function createQuote({ commit }, quote) {
  commit(CREATE_QUOTE, quote);
};

export function copyUpdateCustomer({ dispatch, commit, state }, {originalId}) {
  const quoteId = typeof state.quote !== 'undefined' && typeof state.quote?.id !== 'undefined' && state.quote?.id ? state.quote?.id : originalId;
  const data = new FormData();
  data.append('original_id', originalId);
  data.append('quote_id', quoteId);

  return HTTP.post(`quotes/${quoteId}/customers/copy`, data)
    .then(response => {
      commit(SET_CUSTOMER, response?.data);
      return response;
    });
};

export function createQuoteCustomer({ dispatch, state }, payload) {
  return HTTP.post(`quotes/${state.quote.id}/customers`, payload)
    .then(response => dispatch('fetchQuote', state.quote.id));
};

export function updateQuoteCustomerFull({ commit, state }, { payload, reference }) {
  return BOOKINGHTTP.post(`user/bookings/${reference}/modify-booking/details`, payload)
    .then(response => {
      return response;
    })
    .catch(error => console.log(error));
};

export function updateQuoteCreate({ commit, state }, { bookingId, quoteId, status= null}) {
  let address = `modify-reservation/${bookingId}/update/${quoteId}/pivot`;
  if (status) {
    address = `modify-reservation/${bookingId}/update/${quoteId}/pivot/${status}`;
  }

  return new Promise((resolve,reject)=> {
    return HTTP.get(address)
    .then(response => {
      resolve(response);
      return response;
    })
    .catch(error => console.log(error));
  });
};

export function updateQuoteCustomer({ dispatch, state }, { payload, id }) {
  return HTTP.patch(`quotes/${state.quote.id}/customers/${id}`, payload)
    .then(response => dispatch('fetchQuote', state.quote?.id));
};

export function updateQuotePaymentType({ dispatch, state }, payload) {
    return HTTP.post(`quotes/${payload.quoteId}/update-payment-type`, { 
        paymentType: payload.paymentType
    })
    .then(response => {
        dispatch('fetchQuote', state.quote?.id);

        return response;
    });
};  

export function createVehicle({ commit, dispatch, state }, { selectedVehicle, productId, quoteId = state.quote.id }) {
    return HTTP
        .post(`quotes/${quoteId}/selected-vehicles`, { id: selectedVehicle.id, quote_vehicle_product_id: productId })
        .then(response => {
            dispatch('fetchQuoteWithAdditionalIncludes', {
                quoteId: state.quote.id,
                additionalIncludes: 'selected_vehicle.basic_vehicle,selected_vehicle.premium_vehicle',
            });

            return response;
        });
};

export function assignDefaultVehicle({ commit, dispatch, state }, { selectedVehicle, productId, quoteId = state.quote.id }) {
  return HTTP.post(`quotes/${quoteId}/update/selected-vehicles`, { id: selectedVehicle.id, quote_vehicle_product_id: productId })
    .then(response => {
        dispatch('fetchQuoteWithAdditionalIncludes', {
          quoteId: state.quote.id,
          additionalIncludes: 'selected_vehicle.basic_vehicle,selected_vehicle.premium_vehicle',
        })
        return response;
      }
    );
};

export function modifyBookingVehicle({ commit, dispatch, state }, { selectedVehicle, productId, quoteId, bookingId, bookingReference }) {
  return new Promise((resolve, reject) => {
    return HTTP.post(`quotes/${quoteId}/modify/selected-vehicles/${bookingId}`, { id: selectedVehicle?.id, quote_vehicle_product_id: productId, booking_reference: bookingReference })
      .then(response => {
          commit(FETCH_MODIFICATION, response?.data?.data[0]);
          commit(FETCH_RENTAL_CODE, response?.data?.data[0]?.rental_code);
          resolve(response);
          return response;
        }
      );
  });
};

export function deleteVehicle({ commit, dispatch, state }) {
  return new Promise((resolve, reject) => {
    return HTTP.delete(`quotes/${state.quote.id}/selected-vehicles/${state.quote.selected_vehicle.data.id}`)
      .then(response => {
        commit(DELETE_VEHICLE);
        resolve(response);
      })
    .catch(error => reject(error));
    });
};

export function updateVehicle({ dispatch, state }, { selectedVehicle, productId, quoteId = state?.quote?.id }) {
  return new Promise((resolve, reject) => {
    if (state?.quote?.selected_vehicle && state?.quote?.selected_vehicle?.data?.id) {
      dispatch('deleteVehicle')
        .then(response => {
          dispatch('createVehicle', { selectedVehicle, productId, quoteId })
            .then(response => {
              resolve(response);
            })
            .catch(error => reject(error));
        })
        .catch(error => reject(error));
    } else {

      if (state?.totals && state?.totals?.data > 0) {
        if (state?.totals?.data?.base_rental > 0) {
          dispatch('setDevLocation', true).catch(error => console.log(error));
          dispatch('setMockLocation', 'US').catch(error => console.log(error));
        }
      }
      dispatch('createVehicle', { selectedVehicle, productId, quoteId })
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    }
  });
};

export function updateVehicleWithBooking({ commit, dispatch, state }, { selectedVehicle, productId, bookingId, bookingReference, quoteId = state?.quote?.id }) {
  return new Promise((resolve, reject) => {
    if (state?.totals && state?.totals?.data > 0) {
      if (state?.totals?.data?.base_rental > 0) {
        dispatch('setDevLocation', true).catch(error => console.log(error));
        dispatch('setMockLocation', 'US').catch(error => console.log(error));
      }
    }

    let quoteSelectedExtras = state.modification?.changes?.extras;

    if (quoteSelectedExtras.length === 0) {
      quoteSelectedExtras = state.quote?.selected_extras?.data.map(function (extra) {
        return extra?.extra?.data;
      });
    }

    dispatch('modifyBookingVehicle', { selectedVehicle, productId, quoteId, bookingId, bookingReference })
      .then(response => {
        commit(SET_GRAND_TOTAL, +response?.data?.data[0]?.grand_total);

        const productType = state.modification?.rental_code;

        dispatch('modifyBookingExtras', { quoteSelectedExtras, productType, quoteId, bookingId, bookingReference});

        resolve(response);
        return response;
      })
      .catch(error => console.log(error));
  });
};

export function fetchModification({ commit, dispatch, state }, { bookingId }) {
  return new Promise((resolve, reject) => {
    return HTTP.get(`modify-reservation/${bookingId}/details/${state.quote?.id}`)
      .then(response => {
        commit(FETCH_MODIFICATION, response?.data?.data);
        commit(SET_GRAND_TOTAL, +response?.data);

        resolve(response);
        return response;
      })
      .catch(error => console.log(error));
  });
};

export function fetchModificationWithQuote({ commit, dispatch, state }, { bookingId, quoteId }) {
  return new Promise((resolve, reject) => {
    return HTTP.get(`modify-reservation/${bookingId}/details/${quoteId}`)
      .then(response => {
        resolve(response);
        return response;
      })
      .catch(error => console.log(error));
  });
};

export function updateExtrasWithBooking({ commit, dispatch, state }, { selected, extra, bookingId, booking_reference, quoteId = state.quote.id }) {
  return new Promise((resolve, reject) => {
    let quoteSelectedExtras = {};

    if (
      typeof state.modification?.changes?.extras === 'undefined'
      || (state.modification.changes.options_result === "" && state.modification?.changes?.extras.length === 0)
    ) {
      if (typeof state.quote?.selected_extras !== 'undefined') {
        for (let i = 0; i < state.quote?.selected_extras?.data.length; i++) {
          if ((selected && (extra.external_id !== state.quote?.selected_extras?.data[i]?.extra?.data?.external_id)) || !selected) {
            quoteSelectedExtras[state.quote?.selected_extras?.data[i]?.extra?.data?.external_id] = state.quote?.selected_extras?.data[i]?.extra.data;
          }
        }
      }
    }

    if (typeof state.modification?.changes?.extras !== 'undefined') {
      for (let i = 0; i < state.modification?.changes?.extras?.length; i++) {
        if ((selected && (extra.external_id !== state.modification?.changes?.extras[i]?.external_id)) || !selected) {
          quoteSelectedExtras[state.modification?.changes?.extras[i]?.external_id] = state.modification?.changes?.extras[i];
        }
      }
    }

    if (!selected) {
      quoteSelectedExtras[extra?.external_id] = extra;
    }

    const productType = (typeof state.modification === 'undefined' || typeof state.modification.changes === 'undefined')
      || (typeof state.modification?.changes?.rental_code === 'string' && state.modification?.changes?.rental_code === '')
      || (typeof state.modification?.changes?.errors !== 'undefined')
        ? state.quote?.selected_vehicle?.data?.product?.data?.type
        : state.modification?.changes?.rental_code;

    dispatch('modifyBookingExtras', { quoteSelectedExtras, productType, quoteId, bookingId, bookingReference: booking_reference})
      .then(response => {
          resolve(response);
          return response;
        }
      );
  });
};

  export function modifyBookingExtras({ commit, dispatch, state }, {quoteSelectedExtras, productType, quoteId, bookingId, bookingReference}) {
    return new Promise((resolve, reject) => {
    return HTTP.post(`quotes/${quoteId}/modify/selected-extras/${bookingId}`, { extras: quoteSelectedExtras, product_type: productType, booking_reference: bookingReference })
      .then(response => {
          let extras = typeof response?.data?.data[0]?.extras !== 'undefined' ? response?.data?.data[0]?.extras : [];

          commit(SET_GRAND_TOTAL, +response?.data?.data[0]?.grand_total);
          commit(FETCH_MODIFICATION, response?.data?.data[0]);

          commit(FETCH_MODIFICATION_EXTRAS, extras);
          resolve(response);
          return response;
        }
      );
    });
}

export function checkWebOfficeBooking({ commit, dispatch, state }, { bookingId }) {
  return new Promise((resolve, reject) => {
    return HTTP.post(`modify-reservation/${bookingId}/partial`, { modification: state?.modification?.changes })
      .then(response => {
        commit(FETCH_MODIFICATION, response?.data);
        resolve(response);
        return response;
      }
      );
  });
};

export function confirmWebOfficeBooking({ commit, dispatch, state }, { bookingId: bookingId, quoteId: quoteId }) {
  return new Promise((resolve, reject) => {
    return HTTP.post(`modify-reservation/${bookingId}/partial/confirm`, { booking_reference: bookingId, quote_id_hash: quoteId})
      .then(response => {
        commit(FETCH_MODIFICATION, response?.data?.data[0]);
        resolve(response);
        return response;
      }
      );
  });
};

export function createExtra({ dispatch, state }, payload) {
  //TODO: How to handle multiple items?
  const choice = payload.extra.choices_type == 'boolean' ? true : 1;

  return HTTP.post(`quotes/${state.quote.id}/selected-extras`, { id: payload.extra.id, choice: choice, prepay: payload.prepay })
    .then(response => dispatch('fetchQuote', state.quote.id))
};

export function createVehicleInsuranceOption({ dispatch, state }, payload) {
  return HTTP.post(`quotes/${state.quote.id}/selected-vehicles/${state.quote.selected_vehicle.data.id}/selected-insurance-options`, {
    id: payload.insuranceOption.id,
    prepay: payload.prepay
  }).then(response => dispatch('fetchQuote', state.quote.id));
};

export function deleteVehicleInsuranceOption({ dispatch, state }, selectedInsuranceOption) {
  return HTTP.delete(`quotes/${state.quote.id}/selected-vehicles/${state.quote.selected_vehicle.data.id}/selected-insurance-options/${selectedInsuranceOption.id}`)
    .then(response => dispatch('fetchQuote', state.quote.id));
};

export function updateVehicleInsuranceOption({ dispatch, state }, payload) {
  return HTTP.patch(`quotes/${state.quote.id}/selected-vehicles/${state.quote.selected_vehicle.data.id}/selected-insurance-options/${payload.selectedInsuranceOption.id}`, {
    prepay: payload.prepay,
  }).then(response => dispatch('fetchQuote', state.quote.id));
};

export function deleteExtra({ dispatch, state }, selectedExtra) {
  const selectedExtraIdObjects = state.quote.selected_extras.data.filter(extra => {
    return extra.extra.data.id == selectedExtra.id;
  });
  const selectedExtraIdObject = selectedExtraIdObjects[0];

  return HTTP.delete(`quotes/${state.quote.id}/selected-extras/${selectedExtraIdObject.id}`)
    .then(response => dispatch('fetchQuote', state.quote.id));
};

export function updateExtra({ dispatch, state }, payload) {
  // TODO: Consider pattern(s) for throttling/blocking?
  let selectedExtraIdObjects = [];

  if (state.quote.selected_extras) {
    selectedExtraIdObjects = state.quote.selected_extras.data.filter(extra => {
      return extra.extra.data.id == payload.extra.id;
    });
  }

  if (selectedExtraIdObjects.length) {
    if (payload.choice == 0) {
      dispatch('deleteExtra', payload.extra);
    } else {
      const selectedExtraIdObject = selectedExtraIdObjects[0];

      return HTTP.patch(`quotes/${state.quote.id}/selected-extras/${selectedExtraIdObject.id}`, {
        choice: payload.choice,
        prepay: payload.prepay,
      }).then(response => dispatch('fetchQuote', state.quote.id));
    }
  } else {
    dispatch('createExtra', { extra: payload.extra, prepay: payload.prepay });
  }
};

export function updateQuote({ commit, dispatch, state }, payload) {
  const quoteId = payload.quoteId ? payload.quoteId : state.quote.id;

  if ('payment_type' in payload) {
    commit(UPDATE_PAYMENT_TYPE, payload.payment_type);
  }
  if ('green_heart_donation' in payload) {
    commit(UPDATE_DONATION, payload.green_heart_donation);
  }

  return HTTP.patch(`quotes/${quoteId}`, payload)
    .then(response => {
      dispatch('fetchQuote', state?.quote?.id ? state.quote.id : quoteId);
      dispatch("fetchVehicles", {
        quoteId: state.quote.id,
        sortDriveAndGo: "&sort_drive_and_go",
      });
      dispatch('fetchExtras', state.quote.id);
    });
};

export function updateQuoteLocale({ dispatch, state }, payload) {
  return HTTP.patch(`quotes/${state.quote.id}/locale`, payload)
    .then(response => dispatch('fetchQuote', state.quote?.id));
};

export function fetchTotalsWithoutCommit({ commit }, quoteId) {
  return HTTP.get(`quotes/${quoteId}/totals`)
    .then(response => {
      return response;
    });
};

export function fetchTotals({ commit }, quoteId) {
  return new Promise((resolve, reject) => {
    return HTTP.get(`quotes/${quoteId}/totals`)
      .then(response => {
        commit(FETCH_TOTALS, response?.data?.data);
        commit(SET_GRAND_TOTAL, response?.data?.data?.total);
        resolve(response);
      });
  });
};

export function fetchDonations({ commit }, sourceId) {
  return HTTP.get(`sources/${sourceId}/donation-types`)
    .then(response => commit(FETCH_DONATIONS, response.data.data));
};

export function setCustomerState({ commit }, payload) {
  commit(SET_CUSTOMER_STATE, payload);
};

export function updateBookingQuotesCurrency({ commit, dispatch, state }, { bookingReference, currencyFrom, currencyTo }) {
  return new Promise((resolve, reject) => {
    return HTTP.post(`modify-reservation/${bookingReference}/currency`, { currencyFrom, currencyTo })
      .then(response => {
        resolve(response);
        return response;
      }
      );
  });
};

export function setCurrencyState({ commit, dispatch, state }, currency) {
  new Promise((resolve, reject) => {
    let bookingReference = null;
    const cookie = JSON.parse(localStorage.getItem('booking'));

    if (cookie) {
      bookingReference = cookie.bookingReference;
    }

    if (typeof currency !== 'undefined') {
      const currencyTo = typeof currency !== 'undefined' ? currency.code : null;

      if (currencyTo) {
        localStorage.setItem('currency', currencyTo);

        if (bookingReference) {
          let currencyFrom = state.currency || window.greenmotion.defaultCurrency;
          currencyFrom = currencyFrom.code;
          dispatch('updateBookingQuotesCurrency', { bookingReference, currencyFrom, currencyTo });
        }
        resolve(currencyTo);
      }
    } else {
      resolve();
    }
  }).then(() => {
    if (currency) {
      commit(SET_CURRENCY, currency);
    }
    if (window.bus) {
      window.bus.$emit('fetch-vehicles-on-currency-change');
      window.bus.$emit('fetch-booking-on-currency-change');
    }
  });
};

export function setDefaultCurrency({ commit, dispatch, state }) {
  new Promise((resolve, reject) => {
    resolve(localStorage.getItem('currency'));
  }).then((storedCurrency) => {
    storedCurrency = storedCurrency || window.greenmotion.defaultCurrency;

    const selectedCurrency = state.currencies.filter(currency => {
      return currency.code == storedCurrency;
    });

    if (selectedCurrency) {
      dispatch('setCurrencyState', selectedCurrency[0]);
    }
  });
};

export function setPickupDate({ commit }, date) {
  commit(SET_PICKUP_DATE, date);
};

export function setPickupTime({ commit }, time) {
  commit(SET_PICKUP_TIME, time);
};

export function setDropoffDate({ commit }, date) {
  commit(SET_DROPOFF_DATE, date);
};

export function setDropoffTime({ commit }, time) {
  commit(SET_DROPOFF_TIME, time);
};

export function setPickupLocation({ commit }, location) {
  commit(SET_PICKUP_LOCATION, location);
};

export function setDropoffLocation({ commit }, location) {
  commit(SET_DROPOFF_LOCATION, location);
};

export function linkQuoteUser({ commit }, { userId, quoteId }) {
  return HTTP.post(`${localDomain}quotes/${quoteId}/link`, {
    user_id: userId
  });
};

export function createBooking({ commit }, payload) {
  return HTTP.post('bookings', payload);
};

export function togglePremiumVehicleUpgrade({ commit, dispatch, state }) {
  const selectedVehicle = state.hasUpgradedVehicle ? state.quote.selected_vehicle.data.basic_vehicle.data : state.quote.selected_vehicle.data.premium_vehicle.data;
  dispatch('updateVehicle', { selectedVehicle });
  commit(TOGGLE_PREMIUM_VEHICLE_UPGRADE);
};

export function setSelectedVehicleType({ commit }, type) {
  commit(SET_SELECTED_VEHICLE_TYPE, type);
};

export function intendedRoute({ dispatch, state }, { route }) {
  return new Promise((resolve, reject) => {
    return BOOKINGHTTP.post(`user/create/intended`, {
      intended_url: route
    })
      .then(response => {
          resolve(response);
          return response;
        }
      );
  });
};

export function setTab({ commit }, tab) {
  commit(SET_TAB, tab);
};
